import { render, staticRenderFns } from "./artist-tile.vue?vue&type=template&id=b3a26792&scoped=true"
import script from "./artist-tile.vue?vue&type=script&setup=true&lang=js"
export * from "./artist-tile.vue?vue&type=script&setup=true&lang=js"
import style0 from "./artist-tile.vue?vue&type=style&index=0&id=b3a26792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a26792",
  null
  
)

export default component.exports